import React, { useState } from 'react';

import { Text, ToggleGroup } from '@betterment/samba-react';
import { Card, CenteredWorkflowLayout, WorkflowHeader } from '@betterment/style-closet-react';
import { useNavigate } from 'react-router-dom';

import AllTimeContributions from './components/allTimeContributions';
import CardShimmerLoader from './components/cardShimmerLoader';
import CurrentYearContributions from './components/currentYearContributions';
import IraMatchOfferCard from './components/iraMatchOfferCard';
import { useIraContributionsCurrentYearQuery } from './hooks';

import { WithLayout } from '../RetailApp/components/WithLayout';

const IraContributions: React.FC<React.PropsWithChildren> = () => {
  const [timePeriodSelection, setTimePeriodSelection] = useState('currentYear');
  const { isLoading, iraContributionCurrentYear } = useIraContributionsCurrentYearQuery();
  const navigate = useNavigate();

  const navigateToPreviousPage = () => {
    void navigate(-1);
  };

  return (
    <WithLayout parts={{ sidebar: false }}>
      <CenteredWorkflowLayout>
        <CenteredWorkflowLayout.Slot name="header">
          <WorkflowHeader title="IRA contribution details" closeHandler={navigateToPreviousPage} />
        </CenteredWorkflowLayout.Slot>
        <CenteredWorkflowLayout.Slot name="content">
          {isLoading && <CardShimmerLoader />}
          {!isLoading && iraContributionCurrentYear && (
            <>
              <Card isRounded={true}>
                <Card.Slot name="header">
                  <Text>IRA contributions</Text>
                </Card.Slot>
                <Card.Slot name="body">
                  <ToggleGroup
                    onValueChange={(value: string) => {
                      if (value !== '') {
                        setTimePeriodSelection(value);
                      }
                    }}
                    value={timePeriodSelection}
                    spacing="default"
                    type="single"
                  >
                    <ToggleGroup.Item value="currentYear">
                      <Text>This Year</Text>
                    </ToggleGroup.Item>
                    <ToggleGroup.Item value="allTime">
                      <Text>All Time</Text>
                    </ToggleGroup.Item>
                  </ToggleGroup>
                  {timePeriodSelection === 'currentYear' && (
                    <CurrentYearContributions iraContributionCurrentYear={iraContributionCurrentYear} />
                  )}
                  {timePeriodSelection === 'allTime' && <AllTimeContributions />}
                </Card.Slot>
              </Card>
              <IraMatchOfferCard />
            </>
          )}
        </CenteredWorkflowLayout.Slot>
      </CenteredWorkflowLayout>
    </WithLayout>
  );
};

export default IraContributions;
